export default __webpack_public_path__ + "static/media/githubCompany.c1cdedb8.svg";